import {makeid} from '../helpers/CoreHelpers'
import jwtDecode from "jwt-decode";
import {logout} from "../store/actions/user";

let appDiv = document.getElementById('application');
let Settings = null;

try {
    Settings = require('./../../projectSettings');
    Settings = Settings.Settings();
} catch (e) {
    Settings = null;
}

export default {
    'version': '7.103',
    'authorization': true,
    'name': process.env.APP_NAME,
    'api': {
        'endpoint': window.location.search.includes('dev') ? 'https://acms-starter-dev.awave.io/' : process.env.API_ENDPOINT,
        'cdn': window.location.search.includes('dev') ? 'https://acms-starter-dev.awave.io/' : process.env.CDN_ENDPOINT,
        getCdnEndPoint() {
            if (this.cdn) {
                return this.cdn
            }

            return this.endpoint;
        },
        getWidgetUrl(language) {
            return this.getCdnEndPoint() + "api/Widget/byUrl/" + language + "?url=";
        }
    },
    'language': process.env.LANGUAGE || "en",
    'prefix': 'csod-awave--',
    'adminURL': appDiv ? appDiv.getAttribute('data-admin-url') : "",
    'frontURL': appDiv ? appDiv.getAttribute('data-front-url') : "",
    'client': appDiv ? appDiv.getAttribute('data-client') : "",
    'renderer': appDiv ? appDiv.getAttribute('data-renderer') : "",
    'initialRoute': appDiv ? appDiv.getAttribute('data-initial-route') : "",
    'acmsFullScript': process.env.FULL_SCRIPT ? process.env.FULL_SCRIPT : (appDiv && appDiv.getAttribute("data-full-acms-script") ? appDiv.getAttribute("data-full-acms-script") : "https://acms-starter.awave.io/static/js/main.js"),
    'acmsWidgetScript': process.env.WIDGET_SCRIPT ? process.env.WIDGET_SCRIPT : (appDiv && appDiv.getAttribute("data-widget-acms-script") ? appDiv.getAttribute("data-widget-acms-script") : "https://acms-starter.awave.io/widgets/static/js/main.js"),
    destroy(key) {
        localStorage.removeItem(this.getStoragePrefixes(key));
    },
    set(key, value) {
        localStorage.setItem(this.getStoragePrefixes(key), value);
    },
    get(key) {
        let value = null;
        value = localStorage.getItem(this.getStoragePrefixes(key));

        if (value === "true") {
            return true;
        }
        if (value === "null") {
            return null;
        }
        if (value === "false") {
            return null;
        }

        return value;
    },
    clearStorage() {
        this.destroy('apitoken');
        this.destroy('user');
        this.destroy('ssoId');
    },
    setToken(token) {
        this.set('apitoken', token);
    },
    getToken() {
        let token = this.get('apitoken');

        if (token) {
            let expDate = parseInt(jwtDecode(token).exp, 10) * 1000;
            let currDate = Date.now();

            if (expDate < currDate) {
                this.clearStorage();
                return false;
            }

            if (process.env.SSO !== 'false') {
                if (this.get("csodSession") !== this.getCurrentCsodSessionGuid()) {
                    this.clearStorage();
                    logout();
                    return false;
                }
            }
        }

        return token;
    },
    setUser(userObj) {
        if (userObj) {
            this.set('user', JSON.stringify(userObj));
        } else {
            this.destroy('user');
        }
    },
    getUser() {
        let user = this.get('user');
        if (user) {
            return JSON.parse(user);
        }
        let token = this.getToken();
        if (token) {
            user = jwtDecode(token);
            if (user) {
                return user;
            }
        }
        return null;
    },
    getApiConfig(params) {
        let h = {
            'headers': {
                'pragma': 'no-cache'
            }
        };

        if (params) {
            Object.keys(params).map((key) => {
                h[key] = params[key];
                return null;
            });
        }

        let token = this.getToken();

        if (token) {
            h.headers = {
                ...h.headers,
                'Authorization': 'Bearer ' + this.getToken(),
            }
        }

        return h;
    },
    getId() {
        let id = localStorage.getItem("id");
        if (!id) {
            id = this.generateId();
        }
        return id;
    },
    getStoragePrefixes(key) {
        let id = this.getId();

        if (this.renderer === 'widgets' || this.renderer === 'frontend') {
            return id + 'frontend' + this.client + key;
        } else {
            return id + this.renderer + this.client + key;
        }
    },
    generateId() {
        var id = makeid();
        localStorage.setItem("id", id);
        return id;
    },
    getSsoLink(ssoId) {
        let id = ssoId ? ssoId : makeid();
        this.setSsoId(id);

        if (Settings.front.ssoUrlBase) {
            return Settings.front.ssoUrlBase + id;
        } else {
            return this.api.endpoint + 'api/UserSso/sso/' + id + "?returnUrl=" + encodeURI(window.location.href);
        }
    },
    getSsoId() {
        return this.get('ssoId');
    },
    setSsoId(ssoId) {
        this.set('ssoId', ssoId);
    },
    getCurrentUser() {
        let user = this.getUser();
        if (this.managerViewOn()) {
            let manageAsObj = this.get("manageAs");

            if (manageAsObj) {
                manageAsObj = JSON.parse(manageAsObj);
                user.guid = manageAsObj.guid;
                user.userName = manageAsObj.userName;
                user.userId = manageAsObj.userId;
            }
        }
        return user;
    },
    getCookie(cname) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    },
    getCurrentCsodSessionGuid() {
        return this.getCookie("SessionGuid");
    },
    dev() {
        return false
    }
};



// WEBPACK FOOTER //
// ./src/core/config/index.js